import styled from 'styled-components';

// CONSTANTS
import { ROYAL_BLUE_2, WHITE } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.section`
  .hero,
  &.hero {
    background-color: ${ROYAL_BLUE_2};
    margin-bottom: -40px;

    ${breakpoints.down('sm')} {
      margin-bottom: -16px;
    }

    &__page-content {
      padding-top: 40px;
      padding-bottom: 80px;
      color: ${WHITE};

      ${breakpoints.down('sm')} {
        padding-top: 32px;
        padding-bottom: 60px;
      }
    }

    &__title {
      margin-top: 12px;
    }

    &__subtitle {
      line-height: 17px;
    }
  }
`;

export default Container;
